import React from "react";
import uzdLogo from "../assets/images/uzd_logo_small.jpeg";

// Full-screen branded boot splash — shown by Suspense while a page chunk
// loads (and by any future async auth validation). Matches the login page's
// design language: near-black backdrop, red/green ambient glows.
const splashKeyframes = `
  @keyframes splash-logo-pulse {
    0%, 100% { transform: scale(1);    box-shadow: 0 10px 30px rgba(225,29,46,0.25); }
    50%      { transform: scale(1.04); box-shadow: 0 14px 40px rgba(225,29,46,0.45); }
  }
  @keyframes splash-bar-slide {
    0%   { transform: translateX(-100%); }
    100% { transform: translateX(250%); }
  }
`;

function AppSplash() {
  return (
    <div style={{
      position: "fixed", inset: 0, zIndex: 9999,
      display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center",
      background: "linear-gradient(160deg, #0a0a0a 0%, #141414 55%, #0f1a0f 100%)",
      gap: 26,
    }}>
      <style>{splashKeyframes}</style>

      {/* Ambient glows */}
      <div style={{
        position: "absolute", top: "-15%", left: "-10%", width: 420, height: 420, borderRadius: "50%",
        background: "radial-gradient(circle, rgba(225,29,46,0.22) 0%, transparent 65%)", pointerEvents: "none",
      }} />
      <div style={{
        position: "absolute", bottom: "-18%", right: "-10%", width: 480, height: 480, borderRadius: "50%",
        background: "radial-gradient(circle, rgba(34,197,94,0.18) 0%, transparent 65%)", pointerEvents: "none",
      }} />

      {/* Pulsing logo plate */}
      <div style={{
        background: "#fff", borderRadius: 16, padding: "14px 24px",
        animation: "splash-logo-pulse 1.6s ease-in-out infinite",
      }}>
        <img src={uzdLogo} alt="UZDPART" style={{ height: 46, display: "block", objectFit: "contain" }} />
      </div>

      {/* Slim indeterminate progress bar */}
      <div style={{ width: 160, height: 3, borderRadius: 3, background: "rgba(255,255,255,0.1)", overflow: "hidden" }}>
        <div style={{
          width: "40%", height: "100%", borderRadius: 3,
          background: "linear-gradient(90deg, #e11d2e, #22c55e)",
          animation: "splash-bar-slide 1.1s ease-in-out infinite",
        }} />
      </div>
    </div>
  );
}

export default AppSplash;
